module.exports = __webpack_public_path__ + "img/basic-course.d402056.png";